import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import SVG from 'react-inlinesvg';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import { useCriticalData } from '../../hooks/useTotalCallsData';
import styles from './criticalInformation.module.scss';

export default memo(function CriticalInformation(props) {
    const [t] = useTranslation([props.dictionary, 'common']);

    useCriticalData(props.getData);

    return (
        <Paper className={styles.container}>
            <div className={styles.image} />
            <div className={styles.imageContainer}>
                <span>{t(props.title)}</span>
                <Tooltip
                    className={styles.tooltip}
                    disableFocusListener
                    disableTouchListener
                    title={t(props.description)}
                >
                    <span>{t(props.description)}</span>
                </Tooltip>
                <div className={styles.valueContainer}>
                    {
                        props.data.value &&
                        <CountUp className={styles.value} duration={2} end={props.data.value} redraw />
                    }
                    {
                        props.data.error &&
                        !props.data.value &&
                        <span className={styles.cloudError}>{t('common:no_information_available')}</span>
                    }
                    <div className={styles.loaderContainer}>
                        {props.data.fetching && <CircularLoader light size={24} />}
                        {
                            !props.data.fetching &&
                            props.data.error &&
                            props.data.value &&
                            <Tooltip
                                className={styles.tooltip}
                                disableFocusListener
                                disableTouchListener
                                title={t('dashboard:update_error')}
                            >
                                <div>
                                    <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                                </div>
                            </Tooltip>
                        }
                    </div>
                </div>
            </div>
        </Paper>
    );
}, (prevProps, nextProps) =>
        prevProps.data === nextProps.data &&
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.title === nextProps.title
);
